import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LinkButton, SelectableCard } from '@enamelai/design-system'
import { toSentenceCase } from '@utils/textCase.util'
import './ReportHubCard.css'

export type ReportHubCardProps = {
  title: string
  description: string
  footerLabel: string
  variant?: 'bundle' | 'create' | 'preset'
  domId?: string
  onFooterClick?: () => void
}

const ReportHubCard: React.FC<ReportHubCardProps> = ({
  title,
  description,
  footerLabel,
  variant = 'bundle',
  domId,
  onFooterClick,
}) => {
  const navigate = useNavigate()

  const handleCardClick = (): void => {
    if (onFooterClick) {
      onFooterClick()
      return
    }
    if (variant === 'create') {
      navigate('/report/custom')
      return
    }
    if (variant === 'preset') {
      navigate('/report/presets')
      return
    }
  }

  const handleFooterClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    handleCardClick()
  }

  return (
    <div className="report-hub-card-shell" id={domId}>
      <SelectableCard
        title={toSentenceCase(title)}
        subtitle={toSentenceCase(description)}
        density="comfortable"
        className="report-hub-card"
        onClick={handleCardClick}
        actions={
          <LinkButton
            size="sm"
            underline={false}
            className="report-hub-card__footer"
            onClick={handleFooterClick}
            rightIcon={
              <span
                className="report-hub-card__footer-arrow mgc_right_fill"
                aria-hidden
              />
            }
          >
            {toSentenceCase(footerLabel)}
          </LinkButton>
        }
      />
    </div>
  )
}

export default ReportHubCard
